import React, { useState } from "react";
import { Modal } from "antd"; // Import Modal from Ant Design
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

function EnrolledCoursesList({ courses }) {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [selectedCourse, setSelectedCourse] = useState(null);
	const navigate = useNavigate(); // Initialize navigate for navigation

	const showModal = (course) => {
		setSelectedCourse(course);
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		setSelectedCourse(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setSelectedCourse(null);
	};

	const handleGoToClass = (courseId) => {
		navigate(`/classroom/${courseId}`); // Navigate to the classroom page
	};

	return (
		<div className="mt-8">
			<h3 className="text-2xl font-semibold mb-4">Enrolled Courses</h3>
			{courses.map((course) => (
				<div
					key={course._id}
					className="flex items-center justify-between bg-gray-100 p-4 rounded-lg shadow-md mb-4"
				>
					{/* Course Info */}
					<div className="flex flex-col flex-grow gap-1">
						<h4 className="text-lg font-semibold text-gray-800">
							{course.name}
						</h4>
						<p className="text-sm text-gray-600">
							{course.description}
						</p>
					</div>

					{/* Actions */}
					<div className="flex gap-2 ml-4">
						<button
							onClick={() => showModal(course)}
							className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition duration-300 text-sm"
						>
							View Details
						</button>

						<button
							onClick={() => handleGoToClass(course.classroomId)}
							className="bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition duration-300 text-sm"
						>
							Go to Class
						</button>
					</div>
				</div>
			))}

			{/* Modal for Course Details */}
			<Modal
				title={selectedCourse?.title}
				open={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
			>
				{selectedCourse && (
					<>
						<p>
							<strong>Description:</strong>{" "}
							{selectedCourse.description}
						</p>
						<p>
							<strong>Schedule:</strong>{" "}
							{selectedCourse.schedule.join(", ")}
						</p>
					</>
				)}
			</Modal>
		</div>
	);
}

export default EnrolledCoursesList;
